import React, {useState, useEffect} from 'react';
import {connect} from "react-redux";

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {loadStripe} from "@stripe/stripe-js/pure";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "./CkeckoutForm";
import {Spinner} from "react-bootstrap";


const PaymentProcess = (props)=> {

    const [checkPayment, setCheckPayement] = useState(false);
    const [succeeded, setSucceeded] = useState(false);
    const [itemsTotPrice, setItemsTotPrice] = useState(0.0)
    const [intent, setIntent] = useState()
    const [stipePromise,setStripePromise] = useState(() => loadStripe(props.shop.stripe_pk))



    useEffect(()=>{
        setItemsTotPrice(props.amountHT*props.tax)
        getPayementIntent()
    }, [props.products])

    const getPayementIntent=()=>{
        const args = {
            amountTotal : props.amountHT*(1+props.tax)
        }

        axios.post('/Api/shop/products/intent_setup', args)
            .then(result=>{
                setIntent(result.data)
            })
    }

    const registerSwal = withReactContent(Swal)


    useEffect(()=>{
        (succeeded)?OkPayement():null;
    },[succeeded] )


    const OkPayement = ()=>{

        registerSwal.fire({
            icon: 'success',
            title: 'Réglement',
            text: 'Merci, votre payement à bien été validé',
            confirmButtonText: 'Fermer',
            confirmButtonColor: '#e06f0c'
        }).then(
            window.location.replace("/home")
        )

        setCheckPayement(false)
    }
    const ErrorPayement = (msg)=>{

        registerSwal.fire({
            icon: 'error',
            title: 'Oops...',
            html: '<p>Un problème c\'est produit lors de la création de votre commande!</p><p><b>'+msg+'</b></p>',
            confirmButtonText: 'Fermer',
            footer: '<a href>Contacter les gestionnaires</a>'
        }).then(
            props.handleSubscribProcess()
        )
        setCheckPayement(false)
    }

        return (
                <div className="card">
                    <div className="card-body">
                        {(intent)?
                            <Elements stripe={stipePromise}>
                                <CheckoutForm success={setSucceeded} intent={intent}/>
                            </Elements>
                            :<div className="text-center my-2"><Spinner animation="border" variant={"primary"} size={'sm'}/></div>
                        }
                    </div>
                </div>
        );
}

const mapStateToProps = state => {
    return {
        entity: state.MeReducer.entity,
        shop: state.ShopReducer.shop,
        products: state.ShopCartReducer.products,
        amountHT: state.ShopCartReducer.amountHT,
        tax: state.ShopCartReducer.tax,
        stripePubKey: state.StripeReducer.pubKey,
        intent: state.StripeReducer.paymentIntent,
        order: state.CommandReducer.order,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        setShop: (e) => dispatch({type: 'ADD_SHOP', data: e})
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(PaymentProcess);
